import ReactGA from 'react-ga4';

import { WorkerTabs } from './axios/types';

import { GAEvent, eventMap } from '@/constants/gaevents';

export const initializeGA = (trackingId?: string) => {
  if (!trackingId) return;
  ReactGA.initialize(trackingId);
};

export const logEvent = (
  event: GAEvent | WorkerTabs,
  value?: number | string
) => {
  if (!process.env.GA_TRACKING_ID) return;

  value = value ? Number(value) : undefined;
  const { category, action, label } = eventMap[event];
  ReactGA.event({ category, action, label, value });
};

export const logPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', path });
};
